import React from "react";
import icon_soundoff from "../../../assets/svgs/hyundai/icon-sound-off.svg";
import icon_soundon from "../../../assets/svgs/hyundai/icon-sound-on.svg";
import icon_back from "../../../assets/svgs/avatr/chevron-left.svg";

interface Props {
  isPortrait: boolean,
  audioMute: boolean;
  setAudioMute: (boolean: any) => void;
  returnToShowroom: () => void;
}

const Topbar: React.FC<Props> = ({ isPortrait, audioMute, setAudioMute, returnToShowroom}) => {
  
  return (
    <div className={`studio-sidebar-topbar ${isPortrait ? 'portrait':''}`}>
      <div className={`studio-sidebar-topbar-button ${isPortrait ? 'portrait':''}`} onClick={() => {returnToShowroom()}}>
        <img className={`studio-sidebar-topbar-icon`} src={icon_back} draggable={false} alt=''/>
        <div className={`studio-sidebar-topbar-text ${isPortrait ? 'portrait':''}`}>Atrás</div>
      </div>
      <div className={`studio-sidebar-topbar-music ${isPortrait ? 'portrait':''}`} onClick={() => {setAudioMute(!audioMute)}}>
        <img src={!audioMute ? icon_soundon : icon_soundoff} draggable={false} alt=''/>
      </div>
    </div>
  );
};

export default Topbar;
